<template>
	<div v-if="features.enhancedSearch" :class="{
		'col': columnView,
		'search-open': showMobileSearchBar,
		disabled: tourVisible
	}" class="wpr search-results-wrapper">

		<div class="search-results">
			<div v-if="!hits.length && !loading" class="no-results"> {{ content.search.noResultsMessage }} &nbsp;
				<span class="queryMsg">
					<span v-if="getUrlParameter('language') === 'en'">"</span>
					<span v-else> &lt;&lt;</span>{{ query }}<span v-if="getUrlParameter('language') === 'en'">"</span>
					<span v-else>&gt;&gt;</span>...</span>
				<div class="no-results-suggestions">
					<div v-for="item in content.search.noResults" :key="item.title" class="suggestion-element">
						<span class="no-results-title"> {{ item.title }} </span>
						<p class="no-results-message">
							{{ item.message }}
						</p>
					</div>
				</div>
			</div>
			<scroll-container v-else-if="hits.length" id="search-scroll-container"
				:align="flyerOrientation == 'vertical' ? 'center' : 'left'" :enable-scroll-buttons="displayMode != 'mobile'"
				:fit-axis="flyerOrientation == 'horizontal' ? 'y' : 'x'" :orientation="flyerOrientation" :zoom-level="zoomLevel"
				class="search-results" @contentResize="onResize" @resize="onScrollContainerResize">
				<responsive-grid id="resp-grid" :search-results="true" root-scroll-container="search-scroll-container"
					:flyer-pages="generateResultsPageFromHits(hits)"></responsive-grid>
			</scroll-container>
		</div>
		<!-- FeatureToast  /-->
		<!-- <button @click="resetFilters">Back To<br v-if="!columnView"> Current Flyer</button> -->
	</div>
	<div v-else :class="{
		'col': columnView,
		'search-open': showMobileSearchBar,
		disabled: tourVisible
	}" class="wpr search-results-wrapper">
		<div v-if="noResults" class="no-results"> {{ content.search.noResultsMessage }} &nbsp;
			<span class="queryMsg">
				<span v-if="getUrlParameter('language') === 'en'">"</span>
				<span v-else> &lt;&lt;</span>{{ query }}<span v-if="getUrlParameter('language') === 'en'">"</span>
				<span v-else>&gt;&gt;</span>...</span>

			<div class="no-results-suggestions">
				<div v-for="item in content.search.noResults" :key="item.title" class="suggestion-element">
					<span class="no-results-title"> {{ item.title }} </span>
					<p class="no-results-message">
						{{ item.message }}
					</p>
				</div>

			</div>


		</div>
		<scroll-container v-else id="search-scroll-container" :align="flyerOrientation == 'vertical' ? 'center' : 'left'"
			:enable-scroll-buttons="displayMode != 'mobile'" :fit-axis="flyerOrientation == 'horizontal' ? 'y' : 'x'"
			:orientation="flyerOrientation" :zoom-level="zoomLevel" class="search-results" @contentResize="onResize"
			@resize="onScrollContainerResize">
			<responsive-grid id="resp-grid" :search-results="true" root-scroll-container="search-scroll-container"
				v-bind:flyer-pages="resultsPage"></responsive-grid>
		</scroll-container>
	</div>
</template>

<script>
import GridComponent from "@/components/responsiveGrid.component.vue";
import Page from "@/classes/Page";
import { mapActions, mapState, mapGetters } from 'vuex';
import ScrollContainer from "@/components/scroll-container/ScrollContainer";
//import FeatureToast from "@/components/Toasts/FeatureToast";
import AppConfig from "@/classes/AppConfig";


export default {
	components: {
		ScrollContainer,
		ResponsiveGrid: GridComponent
	},

	props: ['scale'],

	computed: {
		...mapState(['columnView']),
		...mapState('search', ['showMobileSearchBar', 'saving', 'categories', 'subCategories', 'hits', 'loading']),
		...mapGetters('search', ['filteredItems']),
		...mapGetters('screen', ['flyerOrientation', 'displayMode']),
		...mapGetters('scale', ['defPage','defPageGrid']),
		...mapState('scale', ['zoomLevel']),
		...mapState('toast', ['tourVisible']),
		...mapGetters(['content', 'language', 'findBlocksBySKUs', 'storeId', 'dealId']),
		...mapGetters('filters', ['searchQuery']),
		...mapGetters('config', ['features']),


		query() {
			return this.searchQuery?.text;
		},

		resultsPage() {
			const page = Page.GenerateSearchPage(this.filteredItems, this.defPage.type,this.defPageGrid);
			return [page];
		},

		noResults() {
			return !this.resultsPage[0].blocks.length;
		},

		banner() {
			return AppConfig?.AppConf?.algolia_id
		}
	},

	methods: {
		...mapActions('search', ['resetFilters']),
		...mapActions('scale', ['updateScale']),

		generateResultsPageFromHits(hits) {
			const skus = hits.map(hit => hit.sku);
			console.log('SKUs:', skus)
			const page = Page.GenerateSearchPage(this.findBlocksBySKUs(skus), this.defPage.type);
			return [page];
		},

		onScrollContainerResize(scroller) {
			this.updateScale(scroller._sz.getScale());
		},

		onResize() {
			//scroller.scroll({x: 0, y: 0});
		},

		getUrlParameter(name) {
			name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
			var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
			var results = regex.exec(window.location.search);
			return results === null
				? ""
				: decodeURIComponent(results[1].replace(/\+/g, " "));
		},

		checkIfScrolling() {
			return document.querySelector('.search-results .section-container')
		}
	}
}
</script>

<style scoped>
.wpr {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	z-index: 98;
	background-color: rgba(0, 0, 0, 0.5);
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}

.wpr.search-open {
	top: 201px;
}

.wpr.col {
	flex-direction: column;
}

.queryMsg {
	color: #000000;
}

.queryMsgSubheader {
	font-size: 18px !important;
}


.search-results {
	height: 100%;
	width: 100%;
	background-color: #fff;
	padding-bottom: 26px;
}

.no-results {
	font-size: 21px;
	width: 100%;
	height: 100%;
	align-items: center;
	text-align: center;
	background-color: #fff;
	justify-content: center;
	font-weight: bolder;
	padding-top: 30px;
}


.no-results-suggestions {
	display: flex;
	justify-content: center;
	margin-top: 30px;
	width: 60%;
	margin-left: 20%;
}

.suggestion-element {
	padding: 10px;
	width: 33%;
	border-right: none;

}

.suggestion-element:not(:last-child) {
	border-right: 1px solid lightgrey;
}


.no-results-title {
	color: #000000;
}

.no-results-message {
	font-size: 16px;
	font-weight: normal !important;
	margin-top: 10px;
}

.col .search-results {
	width: 100%;
	max-width: inherit;
	/*overflow-y: scroll;
	overflow-x: hidden;*/
}

.col .search-results>* {
	justify-content: center;
	transform-origin: top;
	margin-bottom: 20px;
}

button {
	background-color: #ED1C24;
	color: #FFF;
	border: 1px solid #AFAFAF;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 700;
	padding: 10px 50px;
	margin: auto;
	white-space: nowrap;
	cursor: pointer;
}

@media (max-width: 1024px) {

	/*.wpr {
		flex-direction: column;
	}

	.wpr.pad-top {
		top: 242px;
	}*/
	.wpr button {
		display: none;
	}

	.queryMsgSubheader {
		font-size: 16px !important;
	}

	.no-results-suggestions {
		display: flex;
		flex-direction: column;
		width: 100%;
		margin: 0;
	}

	.no-results {
		font-size: 18.5px;
		text-align: left;
		padding: 35px;
	}

	.suggestion-element {
		margin-top: 20px;
		width: 100%;
		border-right: none;
		padding: 0;
	}

	.suggestion-element:not(:last-child) {
		border-bottom: 1px solid lightgrey !important;
		border-right: none !important;
	}

	.no-results-title {
		color: #000000;
		font-size: 19px;
	}

	.no-results-message {
		font-size: 15px;
		font-weight: normal !important;
		margin-top: 10px;
		margin-bottom: 20px;
	}

	.search-results {
		width: 100%;
		max-width: inherit;
		/* max-height: 80%; */
		/*overflow-y: scroll;
		overflow-x: hidden;*/
	}

}

.search-results-wrapper>div {
	height: 100%;
	width: 100%;
}
</style>
